<script>
export default {
  data () {
    return {
      // sortProp: '',
      // sortOrder: '',
      sort: {
        key: '', // ソートキー
        isAsc: false // 昇順ならtrue,降順ならfalse
      }
    }
  },
  computed: {
    sortCaretAsc: function () {
      return function (prop) {
        if (this.sort.key === prop && this.sort.isAsc) {
          return 'sort-caret ascending active'
        }
        return 'sort-caret ascending'
      }
    },
    sortCaretDesc: function () {
      return function (prop) {
        if (this.sort.key === prop && !this.sort.isAsc) {
          return 'sort-caret descending active'
        }
        return 'sort-caret descending'
      }
    }
  },
  methods: {
    renderHeader (h, e) {
      if (!e.column.sortable && e.column.label) {
        return h('div', null, [
          e.column.label,
          h('span', { class: 'caret-wrapper' }, [
            h('i', {
              class: this.sortCaretAsc(e.column.property),
              on: {
                click: () => this.sortChange(e.column.property, 'asc')
              }
            }, null),
            h('i', {
              class: this.sortCaretDesc(e.column.property),
              on: {
                click: () => this.sortChange(e.column.property, 'desc')
              }
            }, null)
          ])
        ])
      } else {
        return e.column.label
      }
    },
    // sort用キーをセットし、昇順・降順を入れ替える
    // sortBy (nowSelect, table, sort) {
    sortBy (nowColumn, table, sort) {
      // this.sort.isAsc = this.sort.key !== key ? this.sort.isAsc : false
      this.sort.key !== nowColumn.property ? this.sort.isAsc = true : this.sort.isAsc = !this.sort.isAsc
      this.changeCaret(nowColumn)
      this.sort.key = nowColumn.property
      this.sort.class = nowColumn.className
      return this.execSort(table)
    },
    // sortedClass (key) {
    //   return this.sort.key === key ? `sorted ${this.sort.isAsc ? 'asc' : 'desc'}` : ''
    // },
    execSort (table) {
      var list = table.slice()
      // ソート実施
      if (this.sort.key) {
        list.sort((a, b) => {
          a = a[this.sort.key]
          b = b[this.sort.key]
          return (a === b ? 0 : a > b ? 1 : -1) * (this.sort.isAsc ? 1 : -1)
        })
      }
      // for (var i = 0; i <= list.length - 1; i += 1) {
      //   list[i].id = i
      // }
      // this.tableData = list
      return list
    },
    changeCaret (sel) {
      const th = document.getElementsByTagName('th')
      var i = 0
      var j = 0
      for (i = 0; i < th.length; i++) {
        const obj = th[i].querySelectorAll('i')
        for (j = 0; j < obj.length; j++) {
          // 要素からclass="active"を削除する
          obj[j].classList.remove('active')
          // if (th[i].className.match(sel.className)) {
          if (th[i].innerText === sel.label) {
            if (this.sort.isAsc === true) {
              if (obj[j].className.match(/ascending/)) {
                obj[j].classList.add('active')
              }
            } else {
              if (obj[j].className.match(/descending/)) {
                obj[j].classList.add('active')
              }
            }
          }
        }
      }
    }
  }
}
</script>
